// 方法1：使用WebRTC获取本地IP（仅浏览器环境）
export function getLocalIP(timeout = 3000) {
    // 非浏览器环境或浏览器不支持 WebRTC 时，直接返回 null
    if (typeof window === 'undefined' || typeof RTCPeerConnection === 'undefined') {
        return Promise.resolve(null);
    }

    return new Promise((resolve) => {
        let pc = null;
        let timer = null;
        let settled = false;

        // 统一出口：保证只 resolve 一次，并清理所有资源
        const finish = (result) => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            if (pc) {
                pc.onicecandidate = null;
                pc.close();
                pc = null;
            }
            resolve(result);
        };

        // 超时兜底：网络异常或浏览器混淆 IP 导致拿不到结果时，避免 Promise 永远 pending
        timer = setTimeout(() => finish(null), timeout);

        try {
            pc = new RTCPeerConnection({
                iceServers: [{ urls: "stun:stun.l.google.com:19302" }]
            });
        } catch (e) {
            finish(null);
            return;
        }

        pc.createDataChannel("");
        pc.createOffer()
            .then(offer => pc.setLocalDescription(offer))
            .catch(() => finish(null));

        pc.onicecandidate = (ice) => {
            if (!ice.candidate) {
                // 候选收集结束仍没拿到有效 IP，提前结束，不再等超时
                finish(null);
                return;
            }
            const candidate = ice.candidate.candidate || '';
            // 排除 mDNS 混淆地址（形如 xxx.local）和 srflx 中间结果，优先取 host 类型的真实内网 IPv4
            const ipRegex = /(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})/;
            const ipMatch = candidate.match(ipRegex);
            if (ipMatch && !candidate.includes('.local')) {
                finish(ipMatch[0]);
            }
        };

        pc.oniceconnectionstatechange = () => {
            if (pc && ['failed', 'closed', 'disconnected'].includes(pc.iceConnectionState)) {
                finish(null);
            }
        };
    });
}



